/* global setTimeout, clearTimeout, setInterval, clearInterval, localStorage */
angular.module('kareo.ui.shared.modules.idleMonitor', ['kareo.ui.shared.modules.analytics']).provider('idleMonitor', function () {
  var options = {
    // After 1 minute of inactivity, a 10 minutes countdown begins.
    // If the session is still valid, the 10 min countdown resets.
    // The max time a session can be exposed before being logged out is 11 minutes.
    // A better approach to refactor auto logout in the future would be to have a leader tab check session rather than every idle tab.
    idleDuration: 60000, // 1 minutes (milliseconds)
    warningDuration: 600, // 10 minutes (seconds)
    events: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart'
  };
  var idleCallBacks = {};
  var timers = {};
  var state = {
    idling: false, running: false, lastActive: null
  };
  this.$get = [
    '$document', function ($document) {
      function clearIdleTimer() {
        if (timers.idle) {
          clearTimeout(timers.idle);
        }
      }

      function clearWarningInterval() {
        if (timers.warning) {
          clearInterval(timers.warning);
        }
      }

      function writeToLocalStorage() {
        var lastPing = parseInt(localStorage.getItem('lastPing'));
        if (!lastPing || state.lastActive > lastPing) {
          localStorage.setItem('lastPing', state.lastActive);
        }
        if (timeTillIdle() > 1) {
          setTimeout(writeToLocalStorage, timeTillIdle() - 1);
        }
      }

      function warn() {
        if (state.countdown <= 0) {
          clearWarningInterval();
          verifySessionValid()
              .then(isValid => {
                if (isValid) {
                  nowActive();
                } else {
                  idleCallBacks.timeOut();
                }
              })
              .catch(err => {
                // in case a request to check session state fails, we should assume the session is valid and reset idle timer
                nowActive();
              });
        } else {
          idleCallBacks.warn(state.countdown);
          state.countdown--;
        }
      }

      function activeElsewhere(event) {
        if (event.key === 'lastPing' && event.newValue !== event.oldValue) {
          var lastPing = parseInt(event.newValue);
          if (lastPing > state.lastActive) {
            interrupt(lastPing);
          }
        }
      }

      function nowActive() {
        state.idling = false;
        renewIdleTimer();
        clearWarningInterval();
        writeToLocalStorage();
        idleCallBacks.end();
      }

      function timeTillIdle() {
        var idleFor = Date.now() - state.lastActive;
        return options.idleDuration - idleFor;
      }

      function nowIdle() {
        idleCallBacks.start();
        state.idling = true;
        state.countdown = options.warningDuration;
        warn();
        timers.warning = setInterval(warn, 1000);
      }

      function renewIdleTimer() {
        clearIdleTimer();
        timers.idle = setTimeout(nowIdle, timeTillIdle());
      }

      function interrupt(lastActive) {
        state.lastActive = lastActive;
        if (state.idling) {
          nowActive();
        } else {
          renewIdleTimer();
        }
      }

      function listenForActive() {
        function wrapInterrupt() {
          interrupt(Date.now());
        }

        $document.on(options.events, wrapInterrupt);
      }

      function listenForActiveTab() {
        if (window.addEventListener) {
          window.addEventListener('storage', activeElsewhere, false);
        } else {
          window.attachEvent('onstorage', activeElsewhere);
        }
      }

      function setIdleCallbacks(opts) {
        idleCallBacks.timeOut = opts.idleTimeOut || function () {
        };
        idleCallBacks.warn = opts.idleWarn || function () {
        };
        idleCallBacks.start = opts.idleStart || function () {
        };
        idleCallBacks.end = opts.idleEnd || function () {
        };
      }

      function initialize(opts) {
        if (!state.lastActive) {
          state.lastActive = Date.now();
          state.running = true;
          renewIdleTimer();
          writeToLocalStorage();
          listenForActive();
          listenForActiveTab();
          setIdleCallbacks(opts);
        }
      }

      function start(opts) {
        initialize(opts);
      }

      async function verifySessionValid() {
        // We should only auto log user out if we get an invalid sessionStatus (other than 2).
        // Otherwise, keep user logged in.
        var keepUserLoggedIn = true;
        try {
          var sessionId = getCurrentSession();
          if (!sessionId) return false;

          var response = await fetch(`/login-ui/api/Login/session/${sessionId}?refreshTTL=false`);
          if (!response.ok) return keepUserLoggedIn;

          const data = await response.json();
          return data.sessionStatus === 2;
        } catch {
          // in case a request to check session valid fails, we should assume the session is valid and reset idle timer
          return keepUserLoggedIn;
        }
      }

      function getCurrentSession() {
        // Less overhead and minimal memory usage to track _conv_sid instead of all cookies
        // This approach assumes _conv_sid is not HttpOnly.
        var cookies = document.cookie;

        if (cookies.indexOf("_conv_sid=") !== -1) {
          var start = cookies.indexOf("_conv_sid=") + "_conv_sid=".length;
          var end = cookies.indexOf(";", start);

          if (end === -1) {
            end = cookies.length;
          }
          return cookies.substring(start, end);
        }
        return false;
      }

      var svc = {
        _options() {
          return options;
        }, lastActive() {
          return state.lastActive;
        }, running() {
          return state.running;
        }, idling() {
          return state.idling;
        }, state() {
          return state;
        }, start
      };
      return svc;
    }];
});
